import React, { useState } from 'react';
import { CheckCircle } from 'lucide-react';

interface PlanSelectorModalProps {
  isOpen: boolean;
  orgName: string;
  onConfirm: (plan: string) => void;
  onCancel: () => void;
}

const PlanSelectorModal: React.FC<PlanSelectorModalProps> = ({ isOpen, orgName, onConfirm, onCancel }) => {
  const [selectedPlan, setSelectedPlan] = useState('Plan Básico');

  const plans = [
    { name: 'Plan Básico', price: '12,000 COP', features: ['0 cajeros', 'Funcionalidades básicas'] },
    { name: 'Plan Estándar', price: '20,000 COP', features: ['1 cajero', 'Funcionalidades estándar'] },
    { name: 'Plan Premium', price: '32,000 COP', features: ['5 cajeros', 'Funcionalidades completas'] }
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-2">Seleccionar Plan de Suscripción</h2>
          <p className="text-gray-600 mb-6">Organización: <strong>{orgName}</strong></p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            {plans.map((plan) => (
              <div
                key={plan.name}
                onClick={() => setSelectedPlan(plan.name)}
                className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
                  selectedPlan === plan.name
                    ? 'border-blue-500 bg-blue-50'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-semibold text-lg">{plan.name}</h3>
                  {selectedPlan === plan.name && (
                    <CheckCircle className="w-5 h-5 text-blue-500" />
                  )}
                </div>
                <p className="text-2xl font-bold text-blue-600 mb-3">{plan.price}</p>
                <ul className="space-y-1">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="text-sm text-gray-600 flex items-start">
                      <span className="mr-2">•</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="flex justify-end gap-3">
            <button
              onClick={onCancel}
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium"
            >
              Cancelar
            </button>
            <button
              onClick={() => onConfirm(selectedPlan)}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium"
            >
              Activar Suscripción
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanSelectorModal;